import { makeStyles } from "@material-ui/core/styles";
import Body from "../../components/Body";
import Style from "./home.style";
import { Container } from "@cti-workspace/ui";
import { useRef } from "react";

const useStyles = makeStyles(Style);

const HomeRoute = () => {
  console.log("HomeRoute rendering");
  const classes = useStyles();
  const searchRef = useRef(null);
	return (
		<Container className={classes.root}>
      <Body searchRef={searchRef} />
		</Container>
	);
};

export default HomeRoute;
